import { type HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

/**
 * PageGrid — the standard full-width 12-column grid wrapper.
 *
 * Renders `w-full grid-primer` so every child can use `col-span-*` directly.
 * Use this as the outermost content wrapper on any page that needs the
 * Primer grid system.
 *
 * Pair with `PageColumn` for the common centred single-column layout, or use
 * `PageLayout` for the composed convenience wrapper.
 *
 * @example
 * <PageGrid>
 *   <PageColumn className="py-8">
 *     <MyContent />
 *   </PageColumn>
 * </PageGrid>
 */
export interface PageGridProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function PageGrid({ children, className, ...props }: PageGridProps) {
  return (
    <div className={cn('col-span-12 w-full grid-primer', className)} {...props}>
      {children}
    </div>
  );
}

export default PageGrid;
